






















import { Component, Ref, Vue } from 'vue-property-decorator';
import moment, {Moment} from 'moment';
import { detailSheetInstance } from './detailSheetUtils';
import SelectDepartment from '@/components/selectDepartment.vue';
import SelectProject from '@/components/selectProject.vue';
import DetailTable from './components/detailTable.vue';

type IProjectInfo = IProject.IResponse.IProjectInfo;

let exportDates: string[] = [];

@Component({
  name: 'DetailSheet',
  components: {
    DetailTable,
    SelectDepartment,
    SelectProject,
  },
})
export default class DetailSheet extends Vue {
  private dateInterval: Moment[] = [];
  private departmentId: string | undefined = undefined;
  private projectId: string | undefined = undefined;
  @Ref() private readonly detailTable!: DetailTable;
  private sheetInstance = detailSheetInstance;
  private spinning = false;
  private searchType: 0 | 1 = 0;
  get sheetData() {
    return this.sheetInstance.data;
  }
  get placeholder(): string[] {
    let result: string[] = [];
    if (this.searchType === 0) {
      result = [
        this.$t('report.settlementDate').toString(),
        this.$t('report.settlementDate').toString(),
      ];
    } else {
      result = [
        this.$t('report.due').toString(),
        this.$t('report.due').toString(),
      ];
    }
    return result.map((str, index) => {
      const str2 = (index === 0) ? this.$t('operation.start').toString() : this.$t('operation.end').toString();
      return `${str} ${str2}`;
    });
  }
  private destroyed() {
    detailSheetInstance.clearData();
  }
  private handleSearch() {
    if (this.dateInterval.length < 2) {
      this.$message.warning(this.$t('report.selectInterval').toString());
      return;
    }
    exportDates = [];
    const dataDates: string[] = [];
    this.dateInterval.forEach((date, index) => {
      exportDates.push(moment(date).format('YYYY-MM-DD'));
      if (index === 0) {
        date.startOf('d');
      }
      if (index === 1) {
        date.endOf('d');
      }
      // dataDates.push(moment.utc(date).format('YYYY-MM-DD HH:mm:ss'));
      if (this.searchType === 0) {
        dataDates.push(moment.utc(date).format('YYYY-MM-DD HH:mm:ss'));
      } else {
        dataDates.push(date.format('YYYY-MM-DD HH:mm:ss'));
      }
    });
    this.spinning = true;
    this.sheetInstance.requestData({
      StartDate: dataDates[0],
      EndDate: dataDates[1],
      LoadType: this.searchType,
      DepartmentId: this.departmentId,
      ProjectId: this.projectId,
    }).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.spinning = false;
    });
  }
  private handleExport() {
    this.detailTable.exportExcel(exportDates);
  }
  private handleDepartmentChange(departmentId: string) {
    this.departmentId = departmentId || undefined;
  }
  private handleProjectChange(project?: IProjectInfo) {
    if (project) {
      this.projectId = project.id;
    } else {
      this.projectId = undefined;
    }
  }
}

